import {
  LOCALSTORAGE_SERVICE_RESTORE_EXPIRE_DATE_KEY,
  LOCALSTORAGE_SERVICE_RESTORE_KEY,
} from './constants';
import { SavedServiceRestoreState } from './interfaces';

function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

export const checkValidityServiceRestoreState = (serviceRestoreState: object) => {
  return Object.entries(serviceRestoreState).every(
    ([key, value]) => typeof key === 'string' && typeof value === 'string'
  );
};

export const getSavedServiceRestoreState = () => {
  const savedServiceRestoreState: SavedServiceRestoreState = JSON.parse(
    localStorage.getItem(LOCALSTORAGE_SERVICE_RESTORE_KEY) || `{}`
  );

  if (
    !isPlainObject(savedServiceRestoreState) ||
    !checkValidityServiceRestoreState(savedServiceRestoreState)
  ) {
    return {};
  }

  return savedServiceRestoreState;
};

export const setSavedServiceRestoreState = (serviceId: string, shareShortLink: string) => {
  const savedServiceRestoreState = getSavedServiceRestoreState();

  const updatedServiceRestoreState = { ...savedServiceRestoreState, [serviceId]: shareShortLink };

  localStorage.setItem(
    LOCALSTORAGE_SERVICE_RESTORE_KEY,
    JSON.stringify(updatedServiceRestoreState)
  );
};

export const getSavedServiceRestoreByServiceId = (serviceId: string) => {
  const savedServiceRestoreState = getSavedServiceRestoreState();
  return savedServiceRestoreState[serviceId];
};

export const removeSavedServiceRestoreByServiceId = (serviceId: string) => {
  const savedServiceRestoreState = getSavedServiceRestoreState();
  const newServiceRestoreState = { ...savedServiceRestoreState };
  delete newServiceRestoreState[serviceId];

  localStorage.setItem(LOCALSTORAGE_SERVICE_RESTORE_KEY, JSON.stringify(newServiceRestoreState));
};

export const deleteExpiredSavedServiceRestore = () => {
  const serviceRestoreExpireDate = localStorage.getItem(
    LOCALSTORAGE_SERVICE_RESTORE_EXPIRE_DATE_KEY
  );
  const parsedExpireDateTimestamp = JSON.parse(serviceRestoreExpireDate ?? '0');
  const nextExpireDate = new Date().getTime() + 14 * 24 * 60 * 60 * 1000;

  if (!serviceRestoreExpireDate || typeof parsedExpireDateTimestamp !== 'number') {
    localStorage.removeItem(LOCALSTORAGE_SERVICE_RESTORE_KEY);
    localStorage.setItem(LOCALSTORAGE_SERVICE_RESTORE_EXPIRE_DATE_KEY, nextExpireDate.toString());
    return;
  }

  const expireTargetDate = new Date(parsedExpireDateTimestamp);
  const now = new Date();

  if (now.getTime() > expireTargetDate.getTime()) {
    localStorage.removeItem(LOCALSTORAGE_SERVICE_RESTORE_KEY);
    localStorage.setItem(LOCALSTORAGE_SERVICE_RESTORE_EXPIRE_DATE_KEY, nextExpireDate.toString());
  }
};
